import {
  AGGREGATE_CTP_SEASON_3,
  LONGEST_DRIVE_SEASON_3,
  SOCIAL_MEDIA_SEASON_3,
  CTP_SEASON_3,
  LONGEST_DRIVE_SEASON_3_FINAL,
  CTP_PGA_SEASON_3,
} from "@/utils/constants";
import CalculatePrize from "./CalculatePrize";
import PurseCard from "./PurseCard";
import FullPrizeList from "./FullPrizeList";
import {
  getPrizeTable,
  getPurse,
  getTournamentType,
} from "@/utils/tournaments";

interface PurseSeason3Props {
  playersCount: number;
  tournamentName: string;
  tournamentId: string;
  inputVal: string;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PurseSeason3 = ({
  playersCount,
  tournamentName,
  tournamentId,
  inputVal,
  handleInputChange,
}: PurseSeason3Props) => {
  const type = getTournamentType(3, tournamentId, tournamentName);
  const prizeList = getPrizeTable(
    3,
    tournamentId,
    tournamentName,
    playersCount
  );

  if (type.isPGASeason3) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">
                $
                {getPurse(
                  3,
                  tournamentId,
                  tournamentName,
                  playersCount
                ).toLocaleString("en-US")}
              </span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard title="CTP - All Par 3's" prizeList={CTP_PGA_SEASON_3} />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <div className="w-full min-[1041px]:!max-w-[965px]">
        <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">
              $
              {getPurse(
                3,
                tournamentId,
                tournamentName,
                playersCount
              ).toLocaleString("en-US")}
            </span>
            <span className="text-xl text-tm-c-gray-300">Purse</span>
          </li>
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
            <span className="text-xl text-tm-c-gray-300">Players</span>
          </li>
        </ul>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
          <CalculatePrize
            prizeList={prizeList}
            inputVal={inputVal}
            handleInputChange={handleInputChange}
          />
          <PurseCard
            title="Stroke play"
            prizeList={Array.from({ length: 5 }, (_, i) => prizeList?.[i] ?? 0)}
          />
          <PurseCard title="CTP - All Par 3's" prizeList={CTP_SEASON_3} />
          <PurseCard title="Aggregate CTP" prizeList={AGGREGATE_CTP_SEASON_3} />
          <PurseCard
            title="Longest Drive - Men"
            prizeList={
              type.isFinalSeason3
                ? LONGEST_DRIVE_SEASON_3_FINAL
                : LONGEST_DRIVE_SEASON_3
            }
          />
          <PurseCard
            title="Longest Drive - Women"
            prizeList={
              type.isFinalSeason3
                ? LONGEST_DRIVE_SEASON_3_FINAL
                : LONGEST_DRIVE_SEASON_3
            }
          />
          {!type.isFinalSeason3 && (
            <PurseCard title="Social Media" prizeList={SOCIAL_MEDIA_SEASON_3} />
          )}
        </div>
        <FullPrizeList />
      </div>
    </div>
  );
};

export default PurseSeason3;
